import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {LegalRepresentativeServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormRepresentativePersonalInfo from './InnerFormRepresentativePersonalInfo';
import {FieldShape} from 'commons/shapes';
import {formValidator, validateDateonRFCandCURP} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';

RepresentativePersonalInfoForm.propTypes = {
    viewId: PropTypes.number.isRequired,
    viewKey: PropTypes.string.isRequired,
    auxLegalRepresentative: PropTypes.any,
    fieldHandler: PropTypes.func.isRequired,
    personType: PropTypes.string.isRequired,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof RepresentativePersonalInfoForm.propTypes>,
    LegalRepresentativeServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            personTypeKey: '',
            rfc: '',
            name: '',
            lastName: '',
            secondLastName: '',
            birthDate: '',
            rol: '',
            fatherKycId: '',
            curp: '',
            foreignCitizen: '',
            nif: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxLegalRepresentative} = props;
        if (auxLegalRepresentative) {
            return {
                expedientId: auxLegalRepresentative.expedientId || 0,
                workflowId: auxLegalRepresentative.workflowId || 0,
                viewId: auxLegalRepresentative.viewId || 0,
                viewFatherId: auxLegalRepresentative.viewFatherId || 0,
                kycId: auxLegalRepresentative.kycId || 0,
                personTypeKey: auxLegalRepresentative.personTypeKey || '',
                rfc: auxLegalRepresentative.rfc || '',
                name: auxLegalRepresentative.name || '',
                lastName: auxLegalRepresentative.lastName || '',
                secondLastName: auxLegalRepresentative.secondLastName || '',
                birthDate: auxLegalRepresentative.birthDate || null,
                rol: auxLegalRepresentative.rol || '',
                fatherKycId: auxLegalRepresentative.fatherKycId || 0,
                curp: auxLegalRepresentative.curp || '',
                nif: auxLegalRepresentative.nif || '',
                foreignCitizen: auxLegalRepresentative.foreignCitizen || false,
                validationResult: !auxLegalRepresentative.foreignCitizen,
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                personTypeKey: '',
                rfc: '',
                name: '',
                lastName: '',
                secondLastName: '',
                birthDate: null,
                rol: '',
                fatherKycId: 0,
                curp: '',
                nif: '',
                foreignCitizen: false,
                validationResult: false,
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: LegalRepresentativeServiceRequest, props) => {
        const errors: FormikErrors<LegalRepresentativeServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (!values.foreignCitizen) {
            if (values.curp && values.birthDate) {
                if (!validateDateonRFCandCURP(values.birthDate, values.curp))
                    errors.curp = Messages.CURP_NOT_MATCH_WITH_DBO;
            }
            if (values.rfc && values.birthDate) {
                if (!validateDateonRFCandCURP(values.birthDate, values.rfc))
                    errors.rfc = Messages.RFC_NOT_MATCH_WITH_DBO;
            }
            if (values.curp && !values.validationResult) {
                errors.curp = Messages.CURP_VALIDATION_REQUIRED;
            }
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormRepresentativePersonalInfo);

function RepresentativePersonalInfoForm(
    props: InferPropTypes<typeof RepresentativePersonalInfoForm.propTypes>
) {
    const {
        submitHandler,
        fields,
        auxLegalRepresentative,
        personType,
        fieldHandler,
        viewId,
        viewKey,
    } = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            viewId={viewId}
            viewKey={viewKey}
            personType={personType}
            fieldHandler={fieldHandler}
            submitHandler={submitHandler}
            auxLegalRepresentative={auxLegalRepresentative}
        />
    );
}

export default RepresentativePersonalInfoForm;
